import React, { useState, useCallback } from "react";
import Gallery from "react-photo-gallery";
import Carousel, { Modal, ModalGateway } from "react-images";

function Gallary() {
  const photos = [
    {
      src: "images/gallery/1.jpeg",
      width: 8,
      height: 3,
    },
    {
      src: "images/gallery/2.jpeg",
      width: 6,
      height: 3,
    },
    {
      src: "images/gallery/3.jpeg",
      width: 5,
      height: 5,
    },
    {
      src: "images/gallery/4.jpeg",
      width: 5,
      height: 5,
    },
    {
      src: "images/gallery/5.jpeg",
      width: 5,
      height: 5,
    },
    {
      src: "images/gallery/6.jpeg",
      width: 5,
      height: 5,
    },
    {
      src: "images/gallery/7.jpeg",
      width: 5,
      height: 3,
    },
    {
      src: "images/gallery/8.jpeg",
      width: 5,
      height: 5,
    },
    {
      src: "images/gallery/9.jpeg",
      width: 8,
      height: 5,
    },
    {
      src: "images/gallery/10.jpeg",
      width: 5,
      height: 5,
    },
    {
      src: "images/gallery/11.jpeg",
      width: 5,
      height: 5,
    },
    {
      src: "images/gallery/12.jpeg",
      width: 5,
      height: 5,
    },
    {
      src: "images/gallery/13.jpeg",
      width: 4,
      height: 3,
    },
    {
      src: "images/gallery/14.jpeg",
      width: 4,
      height: 3,
    },
    {
      src: "images/gallery/15.jpeg",
      width: 4,
      height: 3,
    },
    {
      src: "images/gallery/16.jpeg",
      width: 4,
      height: 3,
    },
    {
      src: "images/gallery/17.jpeg",
      width: 4,
      height: 3,
    },
    {
      src: "images/gallery/18.jpeg",
      width: 4,
      height: 3,
    },
    {
      src: "images/gallery/19.jpeg",
      width: 4,
      height: 3,
    },
  ];

  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = useCallback((event, { photo, index }) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  }, []);

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  return (
    <>
      <Gallery photos={photos} onClick={openLightbox} />
      <ModalGateway>
        {viewerIsOpen ? (
          <Modal onClose={closeLightbox}>
            <Carousel
              currentIndex={currentImage}
              views={photos.map((x) => ({
                ...x,
                srcset: x.srcSet,
                caption: x.title,
              }))}
            />
          </Modal>
        ) : null}
      </ModalGateway>
    </>
  );
}

export default Gallary;
